import { SET_SELECTED_ENVIRONMENT_TAGS, SET_SELECTED_ENVIRONMENTS } from '@constants/actionTypes';

const defaultState = {
  selectedEnvironmentTags: ['Global'],
  selectedEnvironments: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_SELECTED_ENVIRONMENT_TAGS: {
      return {
        ...state,
        selectedEnvironmentTags: action.payload,
      };
    }
    case SET_SELECTED_ENVIRONMENTS: {
      return {
        ...state,
        selectedEnvironments: action.payload,
      };
    }
    default:
      return state;
  }
};
